export default __webpack_public_path__ + "fonts/Roboto-300-greek4.woff2";